module.exports = __webpack_public_path__ + "static/OpenSans-BoldItalic-f40598dd8ea8593e91ab28aa48130cf1.ttf";